/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

function Buttons({ children, className }) {
  return (
    <div className={`dtv-html5-c-detail-serie__buttons ${className}`}>
      {children}
    </div>
  );
}

Buttons.defaultProps = {
  className: '',
};

Buttons.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default withFocusable()(memo(Buttons));
